import styles from "./styles.module.scss";
import Menu from "../Menu";
import { FormattedMessage } from "react-intl";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Text from "../UI/Text";
import { COLORS } from "../../shared/helpers/colors";
import { clearSession } from "../../shared/storage";
import Avatar from "../Avatar";
import { SIZE } from "../../shared/enums";
import { Employee } from "../../model/user";
import { ACCOUNT } from "../../shared/routes";

type CurrentUserAvatarProps = {
  employeeInfo: Employee | null;
};

const CurrentUserAvatar = ({ employeeInfo }: CurrentUserAvatarProps) => {
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    // @ts-ignore
    window.rudderanalytics.reset();
    clearSession();
    window.location.href = "/";
  }, []);

  const handleAccountClick = useCallback(() => {
    navigate(ACCOUNT);
  }, [navigate]);

  return (
    <Menu
      maxWidth={205}
      activator={
        <div className={styles.CurrentUserAvatar}>
          <Avatar size={SIZE.MD} employeeInfo={employeeInfo} />
          <span className={styles["CurrentUserAvatar-name"]}>
            {employeeInfo?.name}
          </span>
        </div>
      }
    >
      <div className={styles["CurrentUserAvatar-menu"]}>
        <div className={styles["CurrentUserAvatar-menuContainer"]}>
          <button
            className={styles["CurrentUserAvatar-menuActions"]}
            onClick={handleAccountClick}
          >
            <Text noMargin isBlack>
              <FormattedMessage id="dashboard.userMenu.account" />
            </Text>
          </button>
          <button className={styles["CurrentUserAvatar-menuActions"]} disabled>
            <Text noMargin isBlack>
              <FormattedMessage id="dashboard.userMenu.settings" />
            </Text>
          </button>
        </div>
        <button
          className={styles["CurrentUserAvatar-menuLogout"]}
          onClick={handleLogout}
        >
          <Text noMargin sx={{ color: COLORS.red }}>
            <FormattedMessage id="dashboard.userMenu.logout" />
          </Text>
        </button>
      </div>
    </Menu>
  );
};

export default CurrentUserAvatar;
